/**
 * Accepts an array of contentful content (provider guides, care guides or
 * common questions) and returns the guide key and number with the heapId as key
 * value pairs
 *
 * @param {array} content Contentful content
 * @param {key} key The type of guide
 */
export const getHeapIds = ({ content, key }) => {
  const heapIds = {}

  content.forEach((item, index) => {
    heapIds[`${key}${index + 1}`] = item.heapId
  })

  return heapIds
}
